import * as ActionTypes from './types.action';
import basketApi from '../api/basket.api';
import {updateSideBasketStatus} from './loading.action';
import {setCheckoutData} from './checkoutData.action';
import {showItemErrorAlert, showServerErrorAlert} from './error.action';
import {SentryHelper} from '../helpers/sentry.helper';
import {CORRUPTED_BASKET} from '../constants/errorCodes';
import {deleteBasket} from './basket.action';

export function placeBasketOrderSuccess(order) {
  return {
    type: ActionTypes.PLACE_BASKET_ORDER_SUCCESS,
    order
  };
}

export function placeBasketOrder(basketUuid, basketValues, redirectUrl, cancelUrl, futureOrderTime, deviceHash, dineInMsg) {
  return function (dispatch) {
    dispatch(updateSideBasketStatus(true));

    const consumer = {
      name: basketValues.name,
      email: basketValues.email,
      phone: basketValues.phone
    };

    const marketingSubscription = {
      subscribeToEmail: basketValues.emailSubscription || null,
      subscribeToPhone: basketValues.phoneSubscription || null
    };

    let basketComments = basketValues.comments;
    if (dineInMsg && basketValues.comments && basketValues.comments.indexOf(dineInMsg) < 0) {
      basketComments = dineInMsg + basketValues.comments;
    }
    const basketData = {
      redirectUrl: redirectUrl,
      noPaymentUrl: cancelUrl,
      hostedFieldsPayment: false,
      paymentMethod: basketValues.paymentType,
      comments: basketComments,
      consumer,
      marketingSubscription,
      deviceHash
    };

    if (futureOrderTime) {
      basketData.fulfillAt = futureOrderTime.format('YYYY-MM-DDTHH:mm');
    }

    return basketApi.placeBasketOrder(basketUuid, basketData)
      .then(order => {
        dispatch(updateSideBasketStatus(false));
        dispatch(setCheckoutData(consumer));

        if (order.mealChanges) {
          dispatch(showItemErrorAlert(true));
        } else {
          return dispatch(placeBasketOrderSuccess(order));
        }
      })
      .catch(error => {
        if (error.response && error.response.status !== 422) { // 422 - invalid phone number exception
          const isCorruptedBasket = error.response.data && error.response.data.code === CORRUPTED_BASKET;
          if (isCorruptedBasket) {
            dispatch(deleteBasket());
          }
          SentryHelper.logException(new Error(error), {
              basketUuid,
              basketData,
              error: error.response && error.response.data
            },
            { method: 'placeBasketOrder' }
          );

          dispatch(showServerErrorAlert(isCorruptedBasket ? CORRUPTED_BASKET : true));
        }

        dispatch(updateSideBasketStatus(false));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./actions/order.action.js